/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from '@irian-ro/util-environment';

@Injectable({
  providedIn: 'root',
})
export class UserAccountService {
  usersUrl = '/api/auth/users';
  header: HttpHeaders | undefined = undefined;

  constructor(private readonly http: HttpClient, @Optional() private readonly environmentService: EnvironmentService) {
    this.header = new HttpHeaders();
    if (this.environmentService && this.environmentService.getEnvironmentProperty('usersUrl')) {
      this.usersUrl = `${this.environmentService.getEnvironmentProperty('usersUrl')}`;
    }
  }

  changePassword(uuid: string, password: string, accessToken?: string): Observable<any> {
    return this.http.put(`${this.usersUrl}/change-password/${uuid}?access_token=${accessToken}`, { password });
  }

  activateUser(uuid: string, accessToken?: string): Observable<any> {
    return this.http.put(`${this.usersUrl}/activate/${uuid}?access_token=${accessToken}`, null);
  }

  resendEmailConfirmation(mainCredential: string): Observable<any> {
    return this.http.post(`${this.usersUrl}/resend-confirmation-email/${mainCredential}`, mainCredential);
  }

  passwordRecoveryRequest(mainCredential: string): Observable<any> {
    return this.http.post(`${this.usersUrl}/password-recovery-request/${mainCredential}`, null);
  }

  generateOtpForValidation(uuid: string) {
    const headers = new HttpHeaders({
      'x-skip-error-interceptor': 'true',
    });
    return this.http.post(`${this.usersUrl}/user/${uuid}/generate-otp`, null, {
      headers: headers,
    });
  }

  validateCode(uuid: string, phoneValidationInputDTO: any) {
    const headers = new HttpHeaders({
      'x-skip-error-interceptor': 'true',
      'Content-Type': 'application/json; charset=utf-8',
    });

    return this.http.post(`${this.usersUrl}/${uuid}/phone/validate`, phoneValidationInputDTO, { headers: headers });
  }
}
